import { _ as a } from "./index918.mjs";
import { _ as r } from "./index837.mjs";
var o = a, t = r, e = o(t, "WeakMap"), v = e;
export {
  v as _
};
